import { Interval } from '@zapier/design-system-revenue/src/types';

export const buildPlanChangeUrl = (
  changeType: string,
  fromPlanName: string,
  toPlanName: string = '',
  selectedInterval?: Interval
): string => {
  let url = `/app/billing/plans/${changeType}/${fromPlanName.toLocaleLowerCase()}`;

  if (changeType !== 'change') {
    url += `/${toPlanName.toLocaleLowerCase()}`;
  }

  if (selectedInterval) {
    url += `?interval=${selectedInterval}`;
  }

  return encodeURI(url);
};
